export const LOGO_URL = "/logo.webp";

export const CONTACT = {
  address: "Beside St. Ann's College, Ambedkar Colony, Gudimalkapur, Hyderabad, Telangana 500006, India",
  phonePrimary: "+91 99599 29653",
  phoneSecondary: "+91 99599 29178",
  emailPrimary: "info@studentfirstoverseas.in",
  emailSecondary: "studentsfirstconsultants@gmail.com",
  hours: "Monday – Saturday, 10:00 AM – 6:00 PM",
  whatsapp: "https://wa.me/919959929653?text=Hello%20Student%20First%20Overseas%2C%20I%20would%20like%20to%20book%20a%20free%20consultation.",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Beside%20St.%20Ann%27s%20College%2C%20Ambedkar%20Colony%2C%20Gudimalkapur%2C%20Hyderabad%2C%20Telangana%20500006",
  mapsEmbed: "https://www.google.com/maps?q=Beside%20St.%20Ann%27s%20College%2C%20Ambedkar%20Colony%2C%20Gudimalkapur%2C%20Hyderabad%2C%20Telangana%20500006&output=embed",
  cin: "U74999TG2020PTC139351",
};

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/studentfirstconsultants/" },
  { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61565929089206" },
  { name: "Twitter / X", url: "https://twitter.com/studentfirst_in" },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/104462534/" },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1784001727397-1038beb23bca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwY2FtcHVzfGVufDB8fHx8MTc4ODk3MzgwNXww&ixlib=rb-4.1.0&q=85";

export const COUNTRIES = [
  { name: "USA", code: "us", tagline: "Ivy League & world-leading research universities" },
  { name: "UK", code: "gb", tagline: "One-year masters & historic institutions" },
  { name: "Australia", code: "au", tagline: "Post-study work rights & vibrant campuses" },
  { name: "Canada", code: "ca", tagline: "PR pathways & co-op programs" },
  { name: "Germany", code: "de", tagline: "Low tuition & engineering excellence" },
  { name: "France", code: "fr", tagline: "Grandes écoles & business schools" },
  { name: "New Zealand", code: "nz", tagline: "Safe, scenic & research-driven" },
  { name: "Ireland", code: "ie", tagline: "Europe's tech & pharma hub" },
  { name: "Singapore", code: "sg", tagline: "Asia's global education gateway" },
  { name: "Dubai", code: "ae", tagline: "World-class education in a global business hub with tax-free opportunities" },
];

export const SERVICES = [
  { icon: "ClipboardCheck", title: "Free Profile Evaluation", desc: "A honest, no-cost assessment of your academics, scores and goals." },
  { icon: "GraduationCap", title: "University & Course Selection", desc: "Shortlists matched to your profile, budget and career plans." },
  { icon: "FileText", title: "Application Support", desc: "End-to-end application filing, tracking and follow-ups." },
  { icon: "PenLine", title: "LOR & SOP Assistance", desc: "Professional editing that makes your story stand out." },
  { icon: "MessagesSquare", title: "Visa Interview Coaching", desc: "Mock interviews that build real embassy-day confidence." },
  { icon: "Landmark", title: "Education Loan Guidance", desc: "Tie-ups and paperwork help for stress-free funding." },
  { icon: "Plane", title: "Pre-Departure Briefing", desc: "Currency, baggage, SIMs and everything before you fly." },
  { icon: "Home", title: "Airport Pickup & Accommodation", desc: "A soft landing — housing and pickup arranged on arrival." },
];

export const STATS = [
  { value: 1200, suffix: "+", label: "Students Guided" },
  { value: 950, suffix: "+", label: "Visas Approved" },
  { value: 10, suffix: "", label: "Countries Covered" },
  { value: 5, suffix: "+", label: "Years of Experience" },
];

export const HIGHLIGHTS = [
  { icon: "Zap", label: "Rapid Processing" },
  { icon: "BadgeCheck", label: "Zero Prepayment" },
  { icon: "Scale", label: "Transparent Pricing" },
  { icon: "Globe2", label: "24/7 Multilingual Support" },
  { icon: "BookOpen", label: "IELTS / GRE / TOEFL Prep" },
];

export const TESTIMONIALS = [
  { name: "Munawar Khan", program: "MBA – Solent University, UK", text: "I am very thankful and happy to tell you that finally my dream is going to come true because of Student First Overseas constant support. This consultancy helped me for preparing necessary documents and guided me every step of the way. A special shout-out to Afsha Ma'am who has been extremely humble throughout the process." },
  { name: "Syed Shoaib", program: "MSc IT – Central Queensland University, Australia", text: "Student First Overseas has helped me a lot, right from initial counseling throughout the visa process and much more. Excellent service and constant follow-ups at every step." },
  { name: "Harish Reddy", program: "MS in Computer Science – USA", text: "It is one of the best consultancies in Hyderabad. The constant help and follow up they do at every step is remarkable. They made my USA visa process completely smooth." },
  { name: "Mohammed Abdul Rahman", program: "MS in Engineering – Germany", text: "Very genuine and honest team in Mehdipatnam. They do not charge unnecessary fees and clearly explain the documentation requirements. Highly recommended for students aiming for Europe." },
  { name: "Fatima Zohra", program: "Master of Data Science – Canada", text: "The team gave me total clarity on university selection and scholarship options. The mock visa interviews helped build my confidence tremendously before the official appointment." },
  { name: "Rahul Varma", program: "MSc Finance – University of East London, UK", text: "Got my UK CAS letter and visa stamped within record time! Their dedication towards students is genuine and trustworthy." },
  { name: "Tariq Ahmed", program: "Bachelor of Business – Australia", text: "From my transcript evaluation to flight booking and airport pickup assistance, Student First Overseas managed everything flawlessly. Outstanding experience!" },
];

export const SUCCESS_PHOTOS = Array.from({ length: 18 }, (_, i) => `/success/IMG_${5603 + i}.webp`);

export const FAQS = [
  { q: "Which countries do you cover?", a: "We guide students to ten destinations — the USA, UK, Australia, Canada, Germany, France, New Zealand, Ireland, Singapore and Dubai/UAE — across undergraduate, postgraduate and diploma programs." },
  { q: "What services are included?", a: "Everything from free profile evaluation and university shortlisting to SOP/LOR editing, visa interview coaching, education loan guidance, pre-departure briefing, airport pickup and accommodation support." },
  { q: "Do you help with IELTS, TOEFL or GRE preparation?", a: "Yes. We provide structured test-prep guidance for IELTS, TOEFL, GRE and PTE, and help you plan timelines so your scores are ready before application deadlines." },
  { q: "How long does the whole process take?", a: "Typically 3–6 months from first counseling to visa in hand, depending on intake deadlines. Our rapid-processing approach and constant follow-ups keep every step on schedule." },
  { q: "Do you arrange accommodation abroad?", a: "Yes. We assist with student housing, airport pickup and settling-in support in all ten destination countries, so you land with everything already arranged." },
];

export const BLOGS = [
  {
    slug: "top-10-study-visa-mistakes",
    title: "Top 10 Mistakes Students Make While Applying for a Study Visa and How to Avoid Them",
    date: "April 21, 2025",
    img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=900&q=80",
    excerpt: "A single missed document or a copied SOP can undo months of preparation. Here are the ten mistakes we see most — and exactly how to avoid each one.",
    sections: [
      {
        paras: [
          "Every intake season, we meet brilliant students whose study abroad plans were delayed — not because they lacked merit, but because of avoidable mistakes in the application and visa process. The good news: every one of these mistakes is preventable with the right guidance.",
          "After guiding hundreds of students to the USA, UK, Canada, Australia and beyond, here are the ten errors we see most often, and what to do instead.",
        ],
      },
      {
        heading: "The Ten Mistakes",
        list: [
          "Incomplete or improperly attested documents — a single missing attested transcript can stall or sink an otherwise strong application. Arrange and attest every document exactly as required.",
          "A weak or copied Statement of Purpose — SOPs downloaded from the internet are spotted instantly. Your SOP must tell your story, in your voice, tied to your chosen course.",
          "Ignoring university deadlines — every university and intake runs on its own timeline. Missing one deadline can cost you an entire academic year.",
          "Insufficient or poorly presented financial proof — funds must be shown in the exact format and duration the embassy expects, not just in the right amount.",
          "Choosing the wrong course or university — a mismatch between your profile and program is a red flag for visa officers. Shortlist strategically, not emotionally.",
          "Underestimating English test scores — a borderline IELTS or TOEFL score limits both your admissions and your visa chances. Prepare properly and retake if needed.",
          "Errors in application forms — a wrong date, an old passport number or a misspelled name can trigger weeks of delay or outright rejection.",
          "No interview preparation — nervous, inconsistent answers are among the top reasons for visa refusals, especially for the USA F-1. Mock interviews fix this.",
          "Hiding previous refusals or study gaps — embassies already have this information. Honesty, supported by a clear explanation, always works better.",
          "Waiting until the last minute — rushing creates mistakes. Start your process six to eight months before your target intake.",
        ],
      },
      {
        heading: "The Easy Way to Avoid All Ten",
        paras: [
          "Work with counselors who file applications every single week. At Student First Overseas, your documents, SOP, finances and interview preparation are reviewed by specialists before anything is submitted — and it starts with a completely free profile evaluation.",
        ],
      },
    ],
  },
  {
    slug: "ultimate-guide-to-studying-abroad",
    title: "Your Ultimate Guide to Studying Abroad: Everything You Need to Know",
    date: "April 21, 2025",
    img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=900&q=80",
    excerpt: "From picking the right country to landing with accommodation arranged — the complete roadmap we walk every student through, condensed into one guide.",
    sections: [
      {
        paras: [
          "Studying abroad is one of the most rewarding decisions you will ever make — and one of the most process-heavy. This guide compresses the entire journey into the essential steps, in the order you should tackle them.",
        ],
      },
      {
        heading: "Choose Your Destination and Course",
        paras: [
          "Start with your career goal, then work backwards. The USA leads in research and technology, the UK offers intensive one-year master's degrees, Canada and Australia combine quality education with post-study work rights, and Germany offers world-class engineering at very low tuition. Your grades, budget and timeline decide which fits you best.",
        ],
      },
      {
        heading: "Crack the Right Tests",
        paras: [
          "Most universities require an English proficiency score (IELTS, TOEFL or PTE), and many postgraduate programs ask for the GRE or GMAT. Book your test dates early — scores must be ready before application deadlines, and a retake buffer is always wise.",
        ],
      },
      {
        heading: "Get Your Documents in Order",
        paras: [
          "Strong applications are built on complete, consistent paperwork. The core checklist:",
        ],
        list: [
          "Valid passport with enough validity for your full program.",
          "Academic transcripts and degree certificates, attested as required.",
          "A personalized Statement of Purpose that connects your story to the course.",
          "Two to three strong Letters of Recommendation.",
          "Official test score reports (IELTS / TOEFL / GRE / GMAT).",
          "Financial documents in the format your destination embassy expects.",
        ],
      },
      {
        heading: "Plan Your Finances Early",
        paras: [
          "Map the full cost — tuition, living expenses, insurance and travel — before you apply. Scholarships, assistantships and education loans can each cover a part of it. We guide students through loan documentation and scholarship applications so funding never becomes the reason a dream is delayed.",
        ],
      },
      {
        heading: "Ace the Visa",
        paras: [
          "Your visa interview is a conversation about intent and preparation, not an interrogation. Consistent answers, clean financials and genuine academic purpose win approvals. Practice with mock interviews until your story flows naturally.",
        ],
      },
      {
        heading: "Prepare for Departure",
        paras: [
          "Book flights early, arrange forex and an international SIM, understand baggage rules, and confirm your accommodation before you fly. Our pre-departure briefings and airport pickup support mean you land with everything already handled.",
        ],
      },
      {
        heading: "Your Next Step",
        paras: [
          "Reading guides is a great start — but a twenty-minute conversation with a counselor will tell you exactly where your profile stands and what to do first. That conversation is free at Student First Overseas.",
        ],
      },
    ],
  },
];

export const TEAM = [
  { name: "Afshan", role: "Founder & Head Counselor", img: "/afshan.webp", line: "Guides every student personally, from the first call to visa day — and beyond." },
];

export const VALUES = [
  { title: "Personalized Counseling", desc: "One-on-one sessions that map your profile to the right country, course and campus." },
  { title: "Visa Assistance", desc: "Meticulous documentation and mock interviews until your visa is approved." },
  { title: "University Selection", desc: "Accredited universities only — matched to your grades, budget and ambitions." },
  { title: "Pre-Departure Guidance", desc: "Flights, forex, packing and everything you need before take-off." },
  { title: "Accommodation Support", desc: "Verified student housing and airport pickup in your destination city." },
  { title: "Career Planning", desc: "Course choices aligned with where the jobs — and your future — actually are." },
];

export const OFFICE_SPACES = [
  { label: "Reception & Front Desk", img: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=900&q=80" },
  { label: "Counseling Desks", img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=900&q=80" },
  { label: "Visa Preparation Room", img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=900&q=80" },
  { label: "Document Verification Lounge", img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=900&q=80" },
];

export const VISA_TYPES = [
  "USA F-1 Student Visa",
  "UK Student Visa",
  "Canada Study Permit",
  "Australia Student Visa (Subclass 500)",
  "Germany Student Visa",
  "France Student Visa",
  "New Zealand Student Visa",
  "Ireland Student Visa",
  "Singapore Student Pass",
  "Dubai/UAE Student Visa",
  "Not sure yet — need guidance",
];

export const QUALIFICATIONS = [
  "Intermediate / 12th",
  "Bachelor's Degree",
  "Master's Degree",
  "Diploma / Polytechnic",
  "Other",
];

export const DEST_SLIDES = [
  { name: "United Kingdom", short: "UK", city: "London", img: "https://images.unsplash.com/photo-1486299267070-83823f5448dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsb25kb24lMjBiaWclMjBiZW58ZW58MHx8fHwxNzg4OTkwOTYzfDA&ixlib=rb-4.1.0&q=80&w=1920", alt: "Big Ben and the Houses of Parliament in London, United Kingdom" },
  { name: "United States", short: "USA", city: "New York", img: "https://images.pexels.com/photos/356844/pexels-photo-356844.jpeg?auto=compress&cs=tinysrgb&w=1920", alt: "The Statue of Liberty in New York Harbor, USA" },
  { name: "Canada", short: "Canada", city: "Toronto", img: "https://images.unsplash.com/photo-1569982615761-66697da68502?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0b3JvbnRvJTIwY24lMjB0b3dlcnxlbnwwfHx8fDE3ODg5OTA5NjN8MA&ixlib=rb-4.1.0&q=80&w=1920", alt: "CN Tower rising over the Toronto skyline, Canada" },
  { name: "Singapore", short: "Singapore", city: "Marina Bay", img: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzaW5nYXBvcmUlMjBtYXJpbmElMjBiYXklMjBzYW5kc3xlbnwwfHx8fDE3ODg5OTA5NjN8MA&ixlib=rb-4.1.0&q=80&w=1920", alt: "Marina Bay Sands and the Singapore skyline at dusk" },
  { name: "Germany", short: "Germany", city: "Berlin", img: "https://images.unsplash.com/photo-1587330979470-3595ac045ab0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxiZXJsaW4lMjBicmFuZGVuYnVyZyUyMGdhdGV8ZW58MHx8fHwxNzg4OTkwOTYzfDA&ixlib=rb-4.1.0&q=80&w=1920", alt: "Brandenburg Gate in Berlin, Germany" },
  { name: "Australia", short: "Australia", city: "Sydney", img: "https://images.unsplash.com/photo-1624138784614-87fd1b6528f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzeWRuZXklMjBvcGVyYSUyMGhvdXNlfGVufDB8fHx8MTc4ODk5MDk2M3ww&ixlib=rb-4.1.0&q=80&w=1920", alt: "Sydney Opera House on Sydney Harbour, Australia" },
  { name: "New Zealand", short: "New Zealand", city: "Auckland", img: "https://images.unsplash.com/photo-1523049820105-c2e73204bac1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxhdWNrbGFuZCUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3ODg5OTA5NjN8MA&ixlib=rb-4.1.0&q=80&w=1920", alt: "Iconic natural landscape of New Zealand near Auckland" },
  { name: "France", short: "France", city: "Paris", img: "https://images.unsplash.com/photo-1511739001486-6bfe10ce785f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxwaXJpcyUyMGVpZmZlbCUyMHRvd2VyfGVufDB8fHx8MTc4ODk5MDk2M3ww&ixlib=rb-4.1.0&q=80&w=1920", alt: "The Eiffel Tower in Paris, France" },
  { name: "Ireland", short: "Ireland", city: "Dublin", img: "https://images.unsplash.com/photo-1644955508643-e7b550b1ef51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxkdWJsaW4lMjBsYW5kbWFya3xlbnwwfHx8fDE3ODg5OTA5NjN8MA&ixlib=rb-4.1.0&q=80&w=1920", alt: "Iconic landmark and riverfront of Dublin, Ireland" },
  { name: "Dubai", short: "Dubai", city: "UAE", img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1920&q=80", alt: "Burj Khalifa and the Dubai skyline at sunset, United Arab Emirates" },
];
